// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__vBsmU","error":"styles_error__1jrZU","disabled":"styles_disabled__nAeiI","spin":"styles_spin__dG447"};